import { useGetAllConsultantTagsQuery } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { MultiCreatableGroupedSelect } from "@bonliva-crm/ui";
import { Box, FormControl, FormLabel, Typography, makeStyles } from "@material-ui/core";
import { useMemo } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { ConsultantAssignTagsActionFormValues } from "./action-form-values";

type Props = {
  form: UseFormReturn<
    ConsultantAssignTagsActionFormValues,
    any,
    ConsultantAssignTagsActionFormValues
  >;
};

export const AssignTagsAction = ({ form: { control } }: Props) => {
  const classes = useStyles();

  const allTagsQuery = useGetAllConsultantTagsQuery({
    fetchPolicy: "cache-and-network"
  });

  const options = useMemo(() => {
    const tagOptions = (allTagsQuery.data?.getAllConsultantTags.tags || []).map(
      (tag) => ({
        label: tag,
        value: tag
      })
    );
    return [{ label: locale.alreadyAddedTags, options: tagOptions }];
  }, [allTagsQuery.data?.getAllConsultantTags.tags]);

  return (
    <FormControl component="fieldset" className={classes.root}>
      <section style={{ marginTop: "16px" }}>
        <Controller
          render={({ field }) => (
            <Box className={classes.container}>
              <FormLabel>
                <Typography variant="body1">{`${locale.tags}:`}</Typography>
              </FormLabel>
              <MultiCreatableGroupedSelect<{ label: string; value: string }>
                {...field}
                value={field.value?.map((tag) => ({ label: tag, value: tag })) || []}
                onChange={(tags) => field.onChange(tags.map((tag) => tag.value))}
                placeholder=""
                isMulti={true}
                options={options}
                addNewLabel={locale.addNewTag}
                isClearable={false}
                autoFocus={true}
                styleProps={{ menu: { showBorder: true }, control: { showBorder: true } }}
                openMenuOnFocus={true}
                closeMenuOnSelect={false}
              />
            </Box>
          )}
          name="tags"
          control={control}
        />
      </section>
    </FormControl>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  }
}));
